import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import QuizDetailsLanding from '@cont/Quiz/Details/Landing';
import QuizTakingLanding from '@cont/Quiz/Taking/Landing/Landing';
import RevampQuizTakingLanding from '@cont/Quiz/RevampedTaking/Landing/Landing';
import { getCurrentSessionUID, getQuizDetails } from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import useConstants from '@api/hooks/useConstants';
import { getIsTestRevampGoal } from '@api/selectors/constants';
import BaseLayout from './Common/BaseLayout';
import InstructionsPage from './Details/TestRevamp/InstructionsPage';

const Layout = ({ children }) => {
  const { query } = useRouter();
  const { show_instructions, quizUID } = query;

  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));
  const currentSessionUID = useSelectorWithShallowEqual(getCurrentSessionUID);
  const isTestRevamp = useConstants(getIsTestRevampGoal(quizDetails.goal_uid));

  if (show_instructions) {
    return <InstructionsPage />;
  }

  if (currentSessionUID) {
    return (
      <>
        {children}
        {isTestRevamp ? <RevampQuizTakingLanding /> : <QuizTakingLanding />}
      </>
    );
  }

  return (
    <>
      {children}
      <BaseLayout>
        <QuizDetailsLanding />
      </BaseLayout>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
